// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".discount-applier{max-width:30rem}.discount-applier__intro{color:var(--secondary)}.discount-applier .alert,.discount-applier__form{margin-top:var(--spacer-3)}.discount-applier .alert{font-size:var(--font-size-sm)}.discount-applier__input{max-width:200px}", ""]);
// Exports
module.exports = exports;
